import { CAROUSEL_IMAGES, ORDER_ONLINE_URL, DELIVERY_URL, cdnImg } from "../lib/data";

export default function Carousel() {
    // Duplicate the list so the CSS marquee loops seamlessly (translate -50%).
    const items = [...CAROUSEL_IMAGES, ...CAROUSEL_IMAGES];

    return (
        <section
            data-testid="home-carousel"
            className="relative py-16 md:py-24 bg-[#FAF8F4] overflow-hidden"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 mb-10 md:mb-14">
                <div className="flex items-end justify-between gap-6 flex-wrap">
                    <div>
                        <p className="overline mb-3">From The Pass</p>
                        <h2 className="font-display uppercase text-[#121212] text-[clamp(2rem,4.5vw,3.5rem)] leading-[0.95]">
                            Straight from
                            <br />
                            <span className="text-[#EB4A18]">our kitchen.</span>
                        </h2>
                    </div>
                    <p className="overline text-[#6B6B6B] max-w-xs">
                        Burgers, shakes, loaded fries — fresh out the pass.
                    </p>
                </div>
            </div>

            {/* CSS-only marquee — runs on GPU compositor thread,
                doesn't compete with scroll. */}
            <div
                className="relative overflow-hidden"
                style={{
                    maskImage:
                        "linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%)",
                    WebkitMaskImage:
                        "linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%)",
                }}
            >
                <div className="gaffer-marquee-track">
                    {items.map((img, i) => (
                        <figure
                            key={`${img.url}-${i}`}
                            data-testid={`carousel-item-${i}`}
                            className="mx-3 md:mx-4 relative overflow-hidden bg-[#F0EBE3] shrink-0"
                            style={{
                                width: "clamp(260px, 32vw, 460px)",
                                aspectRatio: "1 / 1",
                            }}
                        >
                            <img
                                src={cdnImg(img.url, 600)}
                                alt={img.alt}
                                loading="lazy"
                                decoding="async"
                                className="absolute inset-0 w-full h-full object-cover"
                            />
                        </figure>
                    ))}
                </div>
            </div>

            <div className="mt-10 md:mt-14 flex flex-col items-center gap-4 px-6">
                <div className="flex flex-wrap items-center justify-center gap-4">
                    <a
                        href={ORDER_ONLINE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="carousel-order-online-btn"
                        className="btn-primary text-sm md:text-base px-10 md:px-12 py-4 md:py-5"
                    >
                        Order Pickup
                        <span aria-hidden="true">→</span>
                    </a>
                    <a
                        href={DELIVERY_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="carousel-delivery-btn"
                        className="btn-secondary text-sm md:text-base px-10 md:px-12 py-4 md:py-5"
                    >
                        Get Delivery
                        <span aria-hidden="true">→</span>
                    </a>
                </div>
                <p className="overline text-[0.6rem] text-[#6B6B6B] tracking-[0.28em]">
                    Pickup via Chewzie · Delivery via Uber Eats
                </p>
            </div>
        </section>
    );
}
